import { useState } from "react";
import type { AllowedUser } from "@/lib/types";
import { UserRow } from "./UserRow";

interface Props {
  users: AllowedUser[];
  currentEmail: string | null;
  onRemove: (email: string) => Promise<void>;
}

export function UserList({ users, currentEmail, onRemove }: Props) {
  const [confirmingEmail, setConfirmingEmail] = useState<string | null>(null);

  return (
    <div className="divide-y divide-slate-800">
      {users.map((u) => (
        <UserRow
          key={u.email}
          email={u.email}
          isSelf={currentEmail ? u.email.toLowerCase() === currentEmail.toLowerCase() : false}
          confirming={confirmingEmail === u.email}
          onRequestConfirm={() => setConfirmingEmail(u.email)}
          onCancel={() => setConfirmingEmail(null)}
          onRemove={async () => {
            await onRemove(u.email);
            setConfirmingEmail(null);
          }}
        />
      ))}
    </div>
  );
}
